import axios from 'axios';

/* ========================= initDropdown ========================= */
function initDropdown() {
    console.log('initDropdown');

    const DROPDOWN_SELECTOR = '.dropdown__block';
    const TRIGGER_ATTR = 'data-dropdown-trigger';
    const CLOSE_ATTR = 'data-dropdown-close';
    const MENU_TRIGGER_ATTR = 'data-dropdown-menu-trigger';

    const OPEN_CLASS = 'open';
    const SELECTED_CLASS = 'selected';

    const dropdowns = Array.from(document.querySelectorAll(DROPDOWN_SELECTOR));
    if (!dropdowns.length) return;

    const getBlock = el => el.closest(DROPDOWN_SELECTOR);
    const isInsideAnyDropdown = el => !!el.closest(DROPDOWN_SELECTOR);

    /* ========================= Backdrop (внутри блока) ========================= */
    function showBackdrop(block) {
        if (!block) return null;

        let backdrop = block.querySelector('.dropdown-backdrop');
        if (backdrop) {
            if (!backdrop.classList.contains('fade')) backdrop.classList.add('fade');
            void backdrop.offsetHeight;
            backdrop.classList.add('show');
            return backdrop;
        }

        backdrop = document.createElement('div');
        backdrop.className = 'dropdown-backdrop fade';
        block.appendChild(backdrop);
        void backdrop.offsetHeight;
        backdrop.classList.add('show');

        backdrop.addEventListener('click', (e) => {
            e.stopPropagation();
            closeBlock(block);
        });

        return backdrop;
    }

    function hideBackdrop(block) {
        if (!block) return;
        const backdrop = block.querySelector('.dropdown-backdrop');
        if (!backdrop) return;

        backdrop.classList.remove('show');

        const onEnd = () => {
            if (backdrop.parentNode) backdrop.remove();
        };

        const computed = getComputedStyle(backdrop).transitionDuration || '0s';
        const durMs = parseFloat(computed) * 1000;
        if (durMs > 0) {
            backdrop.addEventListener('transitionend', onEnd, { once: true });
            setTimeout(onEnd, durMs + 100);
        } else {
            onEnd();
        }
    }

    /* ========================= Menu show/hide ========================= */
    function showMenu(block) {
        if (!block) return;
        const menu = block.querySelector('.dropdown__block_menu');
        if (!menu) return;

        menu.removeAttribute('data-closing');
        menu.classList.add('show');

        const trigger = block.querySelector(`[${TRIGGER_ATTR}]`);
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    function hideMenu(block) {
        if (!block) return;
        const menu = block.querySelector('.dropdown__block_menu');
        if (!menu) return;

        const isMobile = window.matchMedia('(max-width: 48rem)').matches;

        if (isMobile) {
            menu.style.transition = 'none';
            menu.classList.remove('show');
            void menu.offsetHeight;
            menu.style.transition = '';

            block.classList.remove('open');
            const trigger = block.querySelector('[data-dropdown-trigger]');
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
            return;
        }

        if (menu.getAttribute('data-closing') === '1') return;
        menu.setAttribute('data-closing', '1');

        menu.classList.remove('show');

        const onEnd = () => {
            menu.removeAttribute('data-closing');
            block.classList.remove('open');
            const trigger = block.querySelector('[data-dropdown-trigger]');
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
            menu.removeEventListener('transitionend', onEnd);
        };

        const computed = getComputedStyle(menu).transitionDuration || '0s';
        const durMs = parseFloat(computed) * 1000;

        if (durMs > 0) {
            menu.addEventListener('transitionend', onEnd, { once: true });
            setTimeout(onEnd, durMs + 100);
        } else {
            onEnd();
        }
    }

    /* ========================= Открытие / закрытие блоков ========================= */
    const openBlock = block => {
        if (!block) return;

        dropdowns.forEach(b => {
            if (b !== block && b.classList.contains(OPEN_CLASS)) {
                const menuB = b.querySelector('.dropdown__block_menu');
                if (menuB) menuB.classList.remove('show');
                hideBackdrop(b);
                b.classList.remove(OPEN_CLASS);
                const triggerB = b.querySelector(`[${TRIGGER_ATTR}]`);
                if (triggerB) triggerB.setAttribute('aria-expanded', 'false');
            }
        });

        block.classList.add(OPEN_CLASS);
        showBackdrop(block);
        showMenu(block);
    };

    const closeBlock = block => {
        if (!block) return;
        hideMenu(block);
        hideBackdrop(block);
    };

    const toggleBlock = block => {
        block.classList.contains(OPEN_CLASS) ? closeBlock(block) : openBlock(block);
    };

    /* ========================= Слушатели внутри блока ========================= */
    dropdowns.forEach(block => {
        const trigger = block.querySelector(`[${TRIGGER_ATTR}]`);
        if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
            trigger.addEventListener('click', e => {
                e.stopPropagation();
                toggleBlock(block);
            });
        }

        const closeBtn = block.querySelector(`[${CLOSE_ATTR}]`);
        if (closeBtn) {
            closeBtn.addEventListener('click', e => {
                e.preventDefault();
                closeBlock(block);
            });
        }

        const menu = block.querySelector('.dropdown__block_menu');
        if (menu) {
            menu.addEventListener('click', e => {
                const target = e.target;

                const cb = target.closest(`[${MENU_TRIGGER_ATTR}]`);
                if (cb && menu.contains(cb)) {
                    e.preventDefault();
                    const selected = cb.classList.toggle(SELECTED_CLASS);
                    cb.setAttribute('aria-pressed', String(selected));
                    return;
                }

                const link = target.closest('a');
                if (link && menu.contains(link)) {
                    const parentBlock = getBlock(link);
                    if (parentBlock) closeBlock(parentBlock);
                    return;
                }
            });
        }
    });

    /* ========================= Глобальные обработчики ========================= */
    document.addEventListener('click', e => {
        if (!isInsideAnyDropdown(e.target)) {
            dropdowns.forEach(block => closeBlock(block));
        }
    });

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            dropdowns.forEach(block => closeBlock(block));
        }
    });
}

/* ========================= updateDropdownParams ========================= */
function updateDropdownParams() {
    const dropdowns = document.querySelectorAll('.dropdown__block');
    const params = new URLSearchParams(window.location.search);

    dropdowns.forEach(dropdown => {
        const menu = dropdown.querySelector('.dropdown__block_menu');
        if (!menu) return;

        const name = menu.dataset.dropdownName || menu.querySelector('[data-dropdown-name]')?.dataset.dropdownName;
        if (!name) return;

        const selected = Array.from(menu.querySelectorAll('.dropdown__block_menu_item.selected'))
            .map(i => i.dataset.dropdownValue)
            .filter(Boolean);

        if (selected.length > 0) {
            params.set(name, selected.join(','));
        } else {
            params.delete(name);
        }
    });

    params.set('page', 1);

    const url = window.location.pathname + '?' + params.toString().replace(/%2C/g, ',');
    window.history.replaceState({}, '', url);

    return `/api/products${url}`;
}

// ========================= Экспорт =========================
export { initDropdown, updateDropdownParams };
